import React from "react";
import KogInputTextLogin from "@/main/components/shared/inputText/inputTextLogin";
import { useRecoveryPassword } from "@/main/hooks/accountRecoveryHook";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useStyles, ButtonLogin, ButtonToggleScreen } from "../../styles";
import * as S from "./styles";
import { getTranslateByKey } from "@/main/services/utils";
import { KeyValue } from "@/main/models/common";

interface ILoginRecoveryPasswordQualitasProps {
	toggleRecoveryPassword: () => void;
	translatesLocal: KeyValue[];
}

export default function LoginRecoveryPasswordQualitas({
	toggleRecoveryPassword,
	translatesLocal,
}: ILoginRecoveryPasswordQualitasProps) {
	const styles = useStyles();
	const formRecoveryPassword = useRecoveryPassword(translatesLocal);

	function handleRecoveryPassword(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		formRecoveryPassword.submit();
	}

	return (
		<S.Container id="recover-password-form" onSubmit={handleRecoveryPassword}>
			<KogInputTextLogin
				autoFocus
				id="txt-recovery-pwd-email"
				className={styles.inputTextCustomQualitas}
				variant="outlined"
				label={getTranslateByKey("information.fillInYourUsername", false, translatesLocal)}
				helperText={formRecoveryPassword.errors.usernameResetPassword?.message}
				error={!!formRecoveryPassword.errors.usernameResetPassword || !!formRecoveryPassword.serverErrors}
				{...formRecoveryPassword.register("usernameResetPassword", {
					required: getTranslateByKey("information.usernameRequired", true, translatesLocal),
				})}
				title={getTranslateByKey("information.fillInYourUsername", false, translatesLocal)}
			/>
			<S.ContainerBackButton>
				<ButtonToggleScreen
					type="button"
					onClick={toggleRecoveryPassword}
					style={{
						color: "#a31e8d",
					}}
				>
					{getTranslateByKey("information.backToLogin", false, translatesLocal)}
				</ButtonToggleScreen>
				<ButtonLogin
					type="submit"
					disabled={formRecoveryPassword.submitInProgress}
					style={{
						background: "#a31e8d",
					}}
				>
					{getTranslateByKey("information.send", false, translatesLocal)}
					<ArrowForward fontSize="small" />
				</ButtonLogin>
			</S.ContainerBackButton>
		</S.Container>
	);
}
